export default "__VITE_ASSET__DL6_DUE3__"